import { AIRPORTS, airportById } from '../data/airports';
import type { Airport } from '../game/types';
import { distanceKm } from '../simulation/math';

export const AIRPORT_GROUP_ORDER = ['亚洲', '欧洲', '非洲', '北美洲', '南美洲', '大洋洲', '跨洋地区'] as const;
export type AirportGroupLabel = typeof AIRPORT_GROUP_ORDER[number];

export interface AirportGroup {
  label: AirportGroupLabel;
  airports: Airport[];
}

export function airportGroupFor(airport: Pick<Airport, 'region'>): AirportGroupLabel {
  switch (airport.region) {
    case '东亚':
    case '东南亚':
    case '南亚':
    case '中东':
      return '亚洲';
    case '欧洲':
      return '欧洲';
    case '非洲':
      return '非洲';
    case '北美':
      return '北美洲';
    case '南美':
      return '南美洲';
    case '大洋洲':
      return '大洋洲';
    default:
      return '跨洋地区';
  }
}

export function groupAirportsForMobile(headquartersId: string, airports: Airport[] = AIRPORTS): AirportGroup[] {
  const groups = new Map<AirportGroupLabel, Airport[]>();
  for (const airport of airports) {
    const label = airportGroupFor(airport);
    const group = groups.get(label);
    if (group) group.push(airport);
    else groups.set(label, [airport]);
  }

  const headquarters = airportById(headquartersId);
  const headquartersGroup = airportGroupFor(headquarters);
  return AIRPORT_GROUP_ORDER
    .filter((label) => groups.has(label))
    .sort((a, b) => (a === headquartersGroup ? -1 : b === headquartersGroup ? 1 : 0))
    .map((label) => ({
      label,
      airports: groups.get(label)!.slice().sort((a, b) => {
        if (a.iata === headquarters.iata) return -1;
        if (b.iata === headquarters.iata) return 1;
        return distanceKm(headquarters, a) - distanceKm(headquarters, b) || a.iata.localeCompare(b.iata);
      }),
    }));
}
